
import React from 'react';
import GasForm from './layout/GasForm';

export default function Referente() {
    return (
            <GasForm title={"Referente"}
                     getAction="/referente/id/{id}"
                     saveAction="/cureferente"
                     showConfirmation={false}
            />
    );
}